/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
/* Generated: 2026-08-20T13:04:09.056Z */

export enum ModalName {
  AgeVerificationModal = 'AgeVerificationModal',
  BuyBoinkersBoostModal = 'BuyBoinkersBoostModal',
  BuyXpBoostModal = 'BuyXpBoostModal',
  FifthDayNotificationModal = 'FifthDayNotificationModal',
  GrabLbPrizesModal = 'GrabLbPrizesModal',
  NewFeatureAlertModal = 'NewFeatureAlertModal',
  NewUsersRefPageModal = 'NewUsersRefPageModal',
  NewXpModal = 'NewXpModal',
  OnboardingModal_R0 = 'OnboardingModal_R0',
  OnboardingModal_R1 = 'OnboardingModal_R1',
  OnboardingModal_R3 = 'OnboardingModal_R3',
  OnboardingModal_R5 = 'OnboardingModal_R5',
  OnboardingModal_R7 = 'OnboardingModal_R7',
  PlaycoinBoostModal = 'PlaycoinBoostModal',
  PlaydeckSubscriptionModal = 'PlaydeckSubscriptionModal',
  PvpModal = 'PvpModal',
  StateIoModal = 'StateIoModal',
  TenthDayNotificationModal = 'TenthDayNotificationModal',
  TopModal = 'TopModal',
  WalletBlockModal = 'WalletBlockModal',
  Wheel100TonPrizeModal = 'Wheel100TonPrizeModal',
  WheelAdModal = 'WheelAdModal',
}
